import type { VerseRef, VerseRange } from '@/types/bible';
import { isVerseRange } from '@/types/bible';

export function classNames(...args: Array<string | false | null | undefined>): string {
  return args.filter(Boolean).join(' ');
}

export function debounce<T extends (...args: never[]) => unknown>(
  fn: T,
  ms: number,
): (...args: Parameters<T>) => void {
  let h: ReturnType<typeof setTimeout> | null = null;
  return (...args: Parameters<T>) => {
    if (h) clearTimeout(h);
    h = setTimeout(() => fn(...args), ms);
  };
}

export function formatRef(r: VerseRef | VerseRange, bookName: (id: string) => string): string {
  if (isVerseRange(r)) {
    const a = r.start;
    const b = r.end;
    if (a.book === b.book && a.chapter === b.chapter) {
      return `${bookName(a.book)} ${a.chapter}:${a.verse}–${b.verse}`;
    }
    return `${bookName(a.book)} ${a.chapter}:${a.verse} – ${bookName(b.book)} ${b.chapter}:${b.verse}`;
  }
  return `${bookName(r.book)} ${r.chapter}:${r.verse}`;
}

export function stripMarkup(text: string): string {
  return text.replace(/⟨\/?\w+⟩/g, '');
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}
